import styled from 'styled-components';

export const LoaderWrapper = styled.div`
    margin-left: 0.75rem;
`;
